import { FunctionComponent, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import TagManager from 'react-gtm-module';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {
    ProjectDashboard,
    ClientDashboard,
    Contributor,
    Community,
    Signin,
    QuestReview,
    QuestDetail,
    TechLead,
    Login,
    ContributorProfile,
    Bugs,
    EditAccount,
    Register,
    ChangePassword,
    AttachmentPage,
    Onboarding,
    GithubCallback,
    ServiceResponse,
    Billing,
    TaskDetail,
    PlanningSession,
    QuestLlmInfoPage,
    TaskLlmInfoPage,
    ProjectLlmInfoPage
} from './pages';

import store from './redux/store';
import { RoutesEnum } from './types/navigation';
import { ThemeProvider } from 'styled-components';
import theme from './theme';

import Snackbar from './shared/Snackbar';

const App: FunctionComponent = () => {
    useEffect(() => {
        const tagManagerArgs = {
            gtmId: `${process.env.REACT_APP_GTM_ID || ''}`
        };
        TagManager.initialize(tagManagerArgs);
    }, []);

    return (
        <Provider store={store}>
            <BrowserRouter>
                <ThemeProvider theme={theme}>
                    <Snackbar />
                    <Routes>
                        <Route
                            path={RoutesEnum.PROJECT_DASHBOARD}
                            element={<ProjectDashboard />}
                        />
                        <Route
                            path={RoutesEnum.CLIENT_DASHBOARD}
                            element={<ClientDashboard />}
                        />
                        <Route path={RoutesEnum.LOGIN} element={<Login />} />
                        <Route
                            path={RoutesEnum.CONTRIBUTOR}
                            element={<Contributor />}
                        />
                        <Route
                            path={RoutesEnum.COMMUNITY}
                            element={<Community />}
                        />
                        <Route
                            path={RoutesEnum.QUEST_DETAIL}
                            element={<QuestDetail />}
                        />
                        <Route
                            path={RoutesEnum.QUEST_REVIEW}
                            element={<QuestReview />}
                        />
                        <Route
                            path={RoutesEnum.PLAN_QUEST}
                            element={<PlanningSession />}
                        />
                        <Route
                            path={RoutesEnum.PLAN_QUEST_SESSION}
                            element={<PlanningSession />}
                        />
                        <Route
                            path={RoutesEnum.ATTACHMENT}
                            element={<AttachmentPage />}
                        />
                        <Route
                            path={RoutesEnum.TECH_LEAD}
                            element={<TechLead />}
                        />
                        <Route
                            path={RoutesEnum.CONTRIBUTOR_PROFILE}
                            element={<ContributorProfile />}
                        />
                        <Route
                            path={RoutesEnum.BILLING}
                            element={<Billing />}
                        />
                        <Route
                            path={RoutesEnum.TASK_DETAIL}
                            element={<TaskDetail />}
                        />
                        <Route
                            path={RoutesEnum.QUEST_LLM_INFO}
                            element={<QuestLlmInfoPage />}
                        />
                        <Route
                            path={RoutesEnum.TASK_LLM_INFO}
                            element={<TaskLlmInfoPage />}
                        />
                        <Route
                            path={RoutesEnum.PROJECT_LLM_INFO}
                            element={<ProjectLlmInfoPage />}
                        />
                        <Route
                            path="*"
                            element={
                                <Navigate to={RoutesEnum.PROJECT_DASHBOARD} />
                            }
                        />
                        <Route path={RoutesEnum.SignIn} element={<Signin />} />
                        <Route path={RoutesEnum.Profile} element={<Signin />} />
                        <Route path={RoutesEnum.BUGS} element={<Bugs />} />
                        <Route
                            path={RoutesEnum.EDIT_ACCOUNT}
                            element={<EditAccount />}
                        />
                        <Route
                            path={RoutesEnum.REGISTER}
                            element={<Register />}
                        />
                        <Route
                            path={RoutesEnum.CHANGE_PASSWORD}
                            element={<ChangePassword />}
                        />
                        <Route
                            path={RoutesEnum.ONBOARDING}
                            element={<Onboarding />}
                        />
                        <Route
                            path={RoutesEnum.GITHUB_CALLBACK}
                            element={<GithubCallback />}
                        />
                        <Route
                            path={RoutesEnum.SERVICE_RESPONSE}
                            element={<ServiceResponse />}
                        />
                    </Routes>
                </ThemeProvider>
            </BrowserRouter>
        </Provider>
    );
};

export default App;
